import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TextField } from '~common/components/form/field-text.component';
import {
  TranslationField,
  TranslationFormData,
} from '~admin/view/components/ui/form/fields/field-translation.component';
import { Box } from '~common/components/box.component';
import { Color } from '~common/model/basics';
import { DeleteIcon } from '~web/view/components/ui/icon/delete.icon';
import { Column } from '~common/components/column.component';

interface Props {
  name: string;
  onRemove?: () => void;
}

export interface EventRestrictionItemFormData {
  description: TranslationFormData<string>[];
  url: TranslationFormData<string>[];
}

export const EventRestrictionItemFields: React.FunctionComponent<Props> = ({ name, onRemove }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <RestrictBox>
        <TranslationField
          name={`${name}.description`}
          label={t('createEvent.eventDetails.restrictions.restrictionItem.description')}
          render={(renderProps): ReactNode => <TextField multiline {...renderProps} />}
        />
        <TranslationField
          name={`${name}.url`}
          label={t('createEvent.eventDetails.restrictions.restrictionItem.url')}
          render={(renderProps): ReactNode => <TextField {...renderProps} />}
        />
      </RestrictBox>
      <IconBox>
        <DeleteIcon
          color={Color.White}
          onClick={(): void => {
            onRemove?.();
          }}
        />
      </IconBox>
    </Container>
  );
};

const Container = styled(Box)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
`;

const RestrictBox = styled(Column)`
  flex: 1 1 auto;
  margin: 0 12px;

  > div:not(:first-child) {
    margin-top: 16px;
  }
`;

const IconBox = styled(Box)`
  flex: 0.1 0.1 auto;
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-restrictions/event-restriction-item-fields.component.tsx